module.exports = __webpack_public_path__ + "img/tddg-3.f49e2502.jpg";